import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Renderer2,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../l_admin/api.service';
import { AuthService } from '../services/auth.service';
import { Boat } from '../l_admin/boat.model';
import { ToastService } from '../l_admin/toast.service';
import { ToastEvent } from '../l_admin/models/toast-event';
import { Subscription } from 'rxjs';

import { SlickCarouselComponent } from 'ngx-slick-carousel';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import flatpickr from 'flatpickr';
import { Modal } from 'bootstrap';
import { getBoatImageUrl, getAccommodationImageUrl, getPriceImageUrl } from '../utils/image-url.util';

declare var $: any;

@Component({
  selector: 'app-detail-boatopen',
  templateUrl: './detail-boatopen.component.html',
  styleUrls: ['./detail-boatopen.component.css'],
})
export class DetailBoatopenComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('flatpickrEl') flatpickrEl!: ElementRef;
  @ViewChild('datepicker') datepicker!: ElementRef;

  @ViewChild('slickModal') slickModal!: SlickCarouselComponent;
  slickConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          swipe: true,
          touchThreshold: 10,
        },
      },
    ],
  };

  private toastSubscription: Subscription;
  toasts: ToastEvent[] = [];
  isAccordionOpen: boolean[] = [];
  isAccordionServicesOpen: boolean[] = [];
  isLoading = false;
  error: string | null = null;
  link_ktg: string = '';
  link_tampil: string = '';
  param: string | null = null;
  durasi: string = '';

  harga_terkecil = '';
  kategori: string | null = null;

  showCarouselModal = false;
  currentCarouselIndex = 0;

  errorMessage: string = '';
  bookForm!: FormGroup;
  submitted = false;

  selectedDate: string = '';
  private modalAcc!: Modal;
  private modalTamu!: Modal;
  private modal!: Modal;

  path_gbr: string = '';

  imageSrc: string = '';
  priceModal!: Modal | null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private authService: AuthService,
    private toastService: ToastService,
    private renderer: Renderer2,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    // private ngImageSliderComponent: NgImageSliderComponent
  ) {
    this.toastSubscription = this.toastService.toastEvents.subscribe(
      (event: ToastEvent) => {
        this.toasts = [...this.toasts, event];
        setTimeout(() => {
          this.toasts = this.toasts.filter((t) => t !== event);
        }, 3000);
      },
    );

    this.isAccordionOpen = this.itineraries.map(() => false);
    this.isAccordionServicesOpen = this.services.map(() => false);

    this.initializeForms();
  }

  private initializeForms() {
    this.bookForm = this.fb.group({
      tamu: ['', [Validators.required]],
      tgl: ['', [Validators.required]],
      accomodation: ['', [Validators.required]],
      total: ['', [Validators.required]],
    });
  }

  // Safely get form control with null check
  getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
    return form.get(controlName);
  }

  // Safely check if control has specific error
  hasError(form: FormGroup, controlName: string, errorType: string): boolean {
    const control = this.getFormControl(form, controlName);
    return control ? this.submitted && control.hasError(errorType) : false;
  }

  get tujuans(): string {
    return this.boat?.ms_tujuans.map((item) => item.tuj).join(', ') || '';
  }

  get keterangans(): string {
    return this.boat?.ms_keterangans.map((item) => item.ket).join(', ') || '';
  }

  get itineraries(): any[] {
    return this.boat?.ms_itineraries || [];
  }

  get services(): any[] {
    return this.boat?.ms_services || [];
  }

  get harga_private(): any[] {
    return this.boat?.ms_priceprivates || [];
  }

  get destinations(): any[] {
    return this.boat?.ms_tujuans || [];
  }

  get accomodations(): any[] {
    return this.boat?.ms_accomodations || [];
  }

  getTotalBeds(acc: any): number {
    return (
      acc.bedDetails?.reduce(
        (sum: number, bed: any) => sum + bed.quantity,
        0,
      ) || 0
    );
  }

  tipe_kabin(tipe: string): string {
    if (tipe === 'private') {
      return 'Private Cabin';
    } else {
      return 'Shared Cabin';
    }
  }

  selectedImageIndex = 0;
  boat: Boat | null = null;

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.loadBoatDetails(slug);
    }

    setTimeout(() => {
      this.modalAcc = new Modal(document.getElementById('accModal')!);
    });

    //Inisialisasi modal Guest
    setTimeout(() => {
      this.modalTamu = new Modal(document.getElementById('guestModal')!);
    });

    //flatpickr Inisialisasi modal Bootstrap
    setTimeout(() => {
      this.modal = new Modal(document.getElementById('dateModal')!);
    });
  }

  loadBoatDetails(slug: string): void {
    this.isLoading = true;
    this.apiService.getBoatBySlug(slug).subscribe({
      next: (boatData) => {
        this.boat = boatData.data;
        this.isLoading = false;

        // console.log(this.destinations);

        if (this.boat) {
          this.link_ktg = 'open-trip-komodo';
          this.link_tampil = 'Komodo National Park';

          const dt_harga = this.harga_private;
          if (dt_harga.length > 0) {
            const dataItem = dt_harga[0];

            const durationLabels: { [key: string]: string } = {
              per_hari: 'One Day Trip',
              dua_hari: '2D1N',
              tiga_hari: '3D2N',
              empat_hari: '4D3N',
              lima_hari: '5D4N',
              enam_hari: '6D5N',
              tujuh_hari: '7D6N',
              delapan_hari: '8D7N',
              sembilan_hari: '9D8N',
              sepuluh_hari: '10D9N',
            };

            //  this.durations = Object.keys(dataItem)
            //  .filter(key =>
            //   key in durationLabels && dataItem[key] !== 0 && dataItem[key] !== null
            //  )
            //  .map(key => durationLabels[key]);
          }

          if (this.boat?.ms_gambarkapals?.length) {
            requestAnimationFrame(() => {
              if (this.slickModal && !this.slickModal.initialized) {
                this.slickModal.initSlick();
              } else if (this.slickModal && this.slickModal.initialized) {
                this.slickModal.slickGoTo(0);
                this.currentCarouselIndex = 0;
              }
              this.cdr.detectChanges();
            });
          }

          if (this.boat?.ms_pricedisplays?.length) {
            this.imageSrc = this.boat?.ms_pricedisplays[0].gambar;
          }

          this.min = 1;
          this.max = this.boat.jumlah_tamu;

          this.durasi = this.boat.durasi;

          // Fetch availability once boat data is loaded
          const now = new Date();
          this.fetchAvailability(now.getMonth() + 1, now.getFullYear());
        }

        // this.slickModal.slickGoTo(0);
      },
      error: (error) => {
        console.error('Error loading boat details', error);
        this.error = 'Failed to load boat details. Please try again later.';
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      complete: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  openCarouselModal(index: number): void {
    this.showCarouselModal = true;
    document.body.style.overflow = 'hidden';

    // Force a change detection cycle to ensure the modal is rendered
    this.cdr.detectChanges();

    // Wait for DOM to be ready and modal to be fully shown
    requestAnimationFrame(() => {
      // Additional check to ensure modal is visible
      if (this.showCarouselModal && this.slickModal) {
        // Unslick first if already initialized
        if (this.slickModal.initialized) {
          this.slickModal.unslick();
        }

        // Wait for modal transition to complete
        setTimeout(() => {
          if (this.slickModal && this.showCarouselModal) {
            try {
              this.slickModal.initSlick();
              // Go to specific slide after initialization
              setTimeout(() => {
                if (this.slickModal?.initialized) {
                  this.slickModal.slickGoTo(index);
                  this.currentCarouselIndex = index;
                  this.cdr.detectChanges();
                }
              }, 0);
            } catch (error) {
              console.error('Error initializing slick carousel:', error);
            }
          }
        }, 150); // Increased timeout to ensure modal is fully visible
      }
    });
  }

  getRemainingPhotosCount(): number {
    return this.boat?.ms_gambarkapals
      ? Math.max(0, this.boat.ms_gambarkapals.length - 3)
      : 0;
  }

  getRemainingPhotosCountmobile(): number {
    return this.boat?.ms_gambarkapals
      ? Math.max(0, this.boat.ms_gambarkapals.length - 1)
      : 0;
  }

  closeCarouselModal(): void {
    if (this.slickModal?.initialized) {
      try {
        this.slickModal.unslick();
      } catch (error) {
        console.error('Error unslicking carousel:', error);
      }
    }

    this.showCarouselModal = false;
    document.body.style.overflow = 'auto';
    this.currentCarouselIndex = 0;
    this.cdr.detectChanges();
  }

  onSlideChange(event: any): void {
    this.currentCarouselIndex = event.currentSlide;
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initFlatpickr();
      this.updateDayPrices();
      // this.calculateTotalPrice();
    }, 10);

    const modalElement = document.getElementById('priceModal');
    if (modalElement) {
      this.priceModal = new Modal(modalElement);
    }
  }

  ngOnDestroy(): void {
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
    }

    this.renderer.removeClass(document.body, 'modal-open');
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    this.renderer.setStyle(document.body, 'padding-right', '');
    this.renderer.removeStyle(document.body, 'overflow');

    this.showCarouselModal = false;
    // this.showGalleryModal = false;

    // this.destroySummernote();

    if (this.slickModal?.initialized) {
      try {
        this.slickModal.unslick();
      } catch (error) {
        console.error('Error cleaning up carousel:', error);
      }
    }

    //flatpickr------------
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  }

  clearSelection() {
    this.flatpickrInstance.selectedDates = null;
    this.selectedDate = '';
    this.formattedDate = '';
    this.totalPrice = '';
    this.tampilTotal = null;
    this.totTamu = 0;
    const tglInput = document.querySelector('#tgl') as HTMLInputElement;
    if (tglInput) {
      tglInput.value = '';
      tglInput.dispatchEvent(new Event('input'));
      tglInput.dispatchEvent(new Event('change'));
    }

    this.tripAcc = null;
    this.totPrice = 0;

    const acc = document.querySelector('#accomodation') as HTMLInputElement;
    if (acc) {
      acc.value = '';
      acc.dispatchEvent(new Event('input'));
      acc.dispatchEvent(new Event('change'));
    }

    const ttl = document.querySelector('#total') as HTMLInputElement;
    if (ttl) {
      ttl.value = '';
      ttl.dispatchEvent(new Event('input'));
      ttl.dispatchEvent(new Event('change'));
    }

    this.flatpickrInstance.clear(); // Clear the date selection in flatpickr
  }

  //jumlah orang
  value: number = 0; // Nilai default
  min: number = 0; // Batas minimal
  max: number = 0; // Batas maksimal
  jumTamu: string = '';

  openModaltamu() {
    this.modalTamu.show();
  }

  applyTamu() {
    if (this.value === 0) {
      return;
    }

    this.modalTamu.hide();
  }

  formattedTotal: string = '';
  totalHarga: number | null = null;

  updateTotalHarga(): void {
    if (this.value > 1) {
      this.totalHarga = this.getTotal();
    } else {
      this.totalHarga = this.getHargaAwalPerOrang();
    }

    this.formattedTotal = this.totalHarga.toString();
  }

  increment(): void {
    if (this.value < this.max) {
      this.value++;
    }

    // this.selectCheapestAccommodation();

    const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
    if (tamuIntput) {
      if (this.value > 0) {
        tamuIntput.value = this.value.toString();
        this.jumTamu = this.value + ' Person';
      } else {
        tamuIntput.value = '';
        this.jumTamu = '';
      }
      tamuIntput.dispatchEvent(new Event('input'));
      tamuIntput.dispatchEvent(new Event('change'));
    }
    this.selectCheapestAccommodation();
    this.updateTotalHarga();
    this.clearSelection();
    // Perbarui harga di kalender dan total harga
    this.updateDayPrices();
    // this.calculateTotalPrice();
  }

  decrement(): void {
    if (this.value > this.min) {
      this.value--;
    }
    // this.selectCheapestAccommodation();
    this.jumTamu = this.value + ' Person';
    const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
    if (tamuIntput) {
      if (this.value > 0) {
        tamuIntput.value = this.value.toString();
        this.jumTamu = this.value + ' Person';
      } else {
        tamuIntput.value = '';
        this.jumTamu = '';
      }
      tamuIntput.dispatchEvent(new Event('input'));
      tamuIntput.dispatchEvent(new Event('change'));
    }
    this.selectCheapestAccommodation();
    this.updateTotalHarga();
    this.clearSelection();
    // Perbarui harga di kalender dan total harga
    this.updateDayPrices();
    // this.calculateTotalPrice();
  }

  validateValue(): void {
    if (this.value < this.min) {
      this.value = this.min;
    } else if (this.value > this.max) {
      this.value = this.max;
    }
  }

  isDecrementDisabled(): boolean {
    return this.value <= this.min;
  }

  isIncrementDisabled(): boolean {
    return this.value >= this.max;
  }

  //tgl
  flatpickrInstance: any;
  tempSelectedDate: string = '';
  totalPrice: string = '';
  tampilTotal: string | null = null;
  formattedDate: string = '';
  selectionDays: number = 0;
  perHari: number = 0;

  // --- Calendar availability ---
  availableSchedules: any[] = [];
  availableDateSet: Set<string> = new Set();
  private availabilityRequestId: number = 0;

  prc: number = 0;

  openModal() {
    // Show the modal
    this.modal.show();
  }

  applyDate() {
    // Check if a date is selected
    const selectedDates = this.flatpickrInstance.selectedDates;
    if (selectedDates.length === 0) {
      return;
    }
    this.modal.hide();
  }

  private getTomorrow(): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const day = String(tomorrow.getDate()).padStart(2, '0');
    const month = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
    const year = tomorrow.getFullYear();

    return `${day}-${month}-${year}`; // Format "dd-mm-yyyy"
  }

  private fetchAvailability(month: number, year: number): void {
    if (!this.boat?.id) return;

    const requestId = ++this.availabilityRequestId;

    // Fetch current month + adjacent months for cross-boundary schedules
    const months: { month: number; year: number }[] = [];
    for (let offset = -1; offset <= 1; offset++) {
      let m = month + offset;
      let y = year;
      if (m < 1) {
        m = 12;
        y--;
      }
      if (m > 12) {
        m = 1;
        y++;
      }
      months.push({ month: m, year: y });
    }

    const boatIds = [this.boat.id];
    let completedRequests = 0;
    let allSchedules: any[] = [];

    months.forEach(({ month: m, year: y }) => {
      this.apiService.getScheduleStatuses(boatIds, m, y).subscribe({
        next: (response: any) => {
          if (requestId !== this.availabilityRequestId) return;
          if (response.success && response.data) {
            allSchedules = allSchedules.concat(response.data);
          }
          completedRequests++;
          if (completedRequests === months.length) {
            const seen = new Set<string>();
            this.availableSchedules = allSchedules.filter((s: any) => {
              if (seen.has(s.schedule_hash)) return false;
              seen.add(s.schedule_hash);
              return true;
            });
            this.computeAvailableDates();
          }
        },
        error: (err: any) => {
          console.error('[fetchAvailability]', err);
          if (requestId !== this.availabilityRequestId) return;
          completedRequests++;
          if (completedRequests === months.length) {
            this.computeAvailableDates();
          }
        },
      });
    });
  }

  private computeAvailableDates(): void {
    this.availableDateSet.clear();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const durationToDays: { [key: string]: number } = {
      'Per Night': 1,
      '2D1N': 2,
      '3D2N': 3,
      '4D3N': 4,
      '5D4N': 5,
      '6D5N': 6,
      '7D6N': 7,
      '8D7N': 8,
      '9D8N': 9,
      '10D9N': 10,
    };

    const days = durationToDays[this.durasi] || 1;
    this.availableSchedules.forEach((schedule: any) => {
      if (schedule.status !== 'available') return;

      const from = new Date(schedule.date_from + 'T00:00:00');
      const to = new Date(schedule.date_to + 'T00:00:00');

      const lastStart = new Date(to);
      lastStart.setDate(lastStart.getDate() - (days - 1));

      const current = new Date(from);
      while (current <= lastStart) {
        if (current >= tomorrow) {
          const key = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}-${String(current.getDate()).padStart(2, '0')}`;
          this.availableDateSet.add(key);
        }
        current.setDate(current.getDate() + 1);
      }
    });

    // Redraw flatpickr to re-trigger onDayCreate with updated availability
    if (this.flatpickrInstance) {
      this.flatpickrInstance.redraw();
    }
  }

  private getPriceForDay(dayIndex: number): number {
    return this.getTotal();
  }

  getHargaAwalPerOrang(): number {
    const sharedCabins = this.accomodations
      .filter((acc) => acc.cabin_type === 'shared' && Number(acc.price) > 0)
      .sort((a, b) => Number(a.price) - Number(b.price));

    if (sharedCabins.length > 0) {
      return Number(sharedCabins[0].price);
    }

    const privateCabins = this.accomodations
      .filter(
        (acc) =>
          acc.cabin_type === 'private' &&
          Number(acc.price) > 0 &&
          Number(acc.capacity) > 0,
      )
      .map((acc) => ({
        pricePerPerson: Number(acc.price) / Number(acc.capacity),
        fullPrice: Number(acc.price),
      }))
      .sort((a, b) => a.pricePerPerson - b.pricePerPerson);

    return privateCabins.length > 0 ? privateCabins[0].pricePerPerson : 0;
  }

  formatUang(amount: number): string {
    if (amount >= 1_000_000_000) {
      // Miliyar (Billion)
      return `IDR ${(amount / 1_000_000_000).toFixed(1)}B`;
    } else if (amount >= 1_000_000) {
      // Juta (Million)
      return `IDR ${(amount / 1_000_000).toFixed(1)}M`;
    } else if (amount >= 1_000) {
      // Ribu (Thousand)
      return `IDR ${(amount / 1_000).toFixed(0)}K`;
    } else {
      // Nilai di bawah seribu (biasa)
      return `IDR ${amount}`;
    }
  }

  private initFlatpickr() {
    this.flatpickrInstance = flatpickr(this.flatpickrEl.nativeElement, {
      dateFormat: 'd/m/Y',
      inline: true,
      static: true,
      defaultDate: this.selectedDate || undefined,
      appendTo: this.flatpickrEl.nativeElement.parentElement,
      minDate: this.getTomorrow(),
      maxDate: '31-12-2027',
      enableTime: false,
      showMonths: 1,
      prevArrow:
        '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16l-4-4m0 0l4-4m-4 4h18"></path></svg>',
      nextArrow:
        '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>',
      onChange: (selectedDates) => {
        if (
          !selectedDates.length ||
          this.flatpickrInstance.config.preventRecursion
        )
          return;

        this.flatpickrInstance.config.preventRecursion = true;

        const durationToDays: { [key: string]: number } = {
          'Per Night': 1,
          '2D1N': 2,
          '3D2N': 3,
          '4D3N': 4,
          '5D4N': 5,
          '6D5N': 6,
          '7D6N': 7,
          '8D7N': 8,
          '9D8N': 9,
          '10D9N': 10,
        };

        this.selectionDays = durationToDays[this.durasi] || 0;

        const startDate = selectedDates[0];
        const tempDates = Array.from({ length: this.selectionDays }, (_, i) => {
          const date = new Date(startDate);
          date.setDate(startDate.getDate() + i);
          return date;
        });

        this.flatpickrInstance.setDate(tempDates, false);

        // Set the selected date
        this.selectedDate = selectedDates[0].toLocaleDateString('id-ID'); // Format it to display as string

        this.updateFooter(tempDates);
        this.updateDayPrices();

        // console.log(tempDates);

        this.flatpickrInstance.config.preventRecursion = false;
      },
      onDayCreate: (datesArr, dateStr, instance, dayElem) => {
        const dayNum = parseInt(dayElem.innerText, 10);
        const month = instance.currentMonth;
        const year = instance.currentYear;

        const date = new Date(year, month, dayNum);
        const dayIndex = date.getDay();

        if (this.getPriceForDay(dayIndex)) {
          this.prc = this.getPriceForDay(dayIndex);
        } else {
          this.prc = this.getHargaAwalPerOrang();
        }

        dayElem.innerHTML = `
      <span class="dayNum">${dayNum}</span>
      <span class="dayPrice">${this.formatUang(this.prc)}</span>
      `;

        // Check schedule availability — disable dates not in available set
        const dateKey = `${year}-${String(month + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
        if (!this.availableDateSet.has(dateKey)) {
          dayElem.classList.add('flatpickr-day-secondary');
          dayElem.classList.add('notAllowed');
        } else {
          dayElem.classList.remove('flatpickr-day-secondary');
          dayElem.classList.remove('notAllowed');
        }
      },
      onReady: () => {
        const monthInput = document.querySelector(
          'select.flatpickr-monthDropdown-months',
        ) as HTMLInputElement;
        const yearInput = document.querySelector(
          '.numInput.cur-year',
        ) as HTMLInputElement;

        if (monthInput) monthInput.disabled = true;
        if (yearInput) {
          yearInput.disabled = true;
          document
            .querySelector('span.arrowUp')
            ?.setAttribute('style', 'display: none');
          document
            .querySelector('span.arrowDown')
            ?.setAttribute('style', 'display: none');
        }

        // Fetch availability for the initial month
        const now = new Date();
        this.fetchAvailability(now.getMonth() + 1, now.getFullYear());
      },

      // Event yang dipanggil ketika bulan diubah
      onMonthChange: (selectedDates, dateStr, instance) => {
        this.updateDayPrices();
        this.fetchAvailability(instance.currentMonth + 1, instance.currentYear);
      },

      // Event yang dipanggil ketika tahun diubah
      onYearChange: (selectedDates, dateStr, instance) => {
        this.updateDayPrices();
        this.fetchAvailability(instance.currentMonth + 1, instance.currentYear);
      },
    });

    this.flatpickrInstance.config.preventRecursion = false;
  }

  private updateDayPrices() {
    if (!this.flatpickrInstance) return;

    const dayElements = document.querySelectorAll('span.flatpickr-day');
    const selectedDates = this.flatpickrInstance.selectedDates;
    const sortedSelectedDates = [...selectedDates].sort(
      (a, b) => a.getTime() - b.getTime(),
    );

    dayElements.forEach((dayElem: any) => {
      const ariaLabel = dayElem.getAttribute('aria-label');

      if (!ariaLabel) return;

      const dayDateObj = new Date(ariaLabel);
      const isSelected = sortedSelectedDates.some(
        (date) => date.toDateString() === dayDateObj.toDateString(),
      );

      const isFirstDate =
        sortedSelectedDates.length > 0 &&
        sortedSelectedDates[0].toDateString() === dayDateObj.toDateString();

      const dayNum = dayElem.innerHTML;

      // Hitung harga untuk hari tersebut
      const dayIndex = parseInt(dayNum, 10) - 1; // Hari pertama = 0
      const price = this.getPriceForDay(dayIndex);

      const priceElem = dayElem.querySelector('.dayPrice');
      if (priceElem) {
        if (isSelected && !isFirstDate) {
          priceElem.style.display = 'none'; // Sembunyikan elemen
        } else {
          priceElem.style.display = ''; // Tampilkan elemen kembali (gunakan default CSS)
          priceElem.textContent = this.formatUang(price); // Atur konten harga
        }
      }
    });
  }

  private updateFooter(selectedDates: Date[]) {
    if (selectedDates.length === 0) return;

    const startDate = selectedDates[0];
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + (this.selectionDays - 1));

    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
    };
    this.formattedDate = `${startDate.toLocaleDateString('en-GB', options)} - ${endDate.toLocaleDateString('en-GB', options)}`;

    if (this.getTotal() > 0) {
      this.totalPrice = this.getTotal().toString();
    } else {
      this.totalPrice = this.getHargaAwalPerOrang().toString();
    }

    const tglInput = document.querySelector('#tgl') as HTMLInputElement;
    if (tglInput) {
      const opt: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      };
      this.selectedDate = selectedDates[0].toLocaleDateString('en-GB', opt);
      const startDateString = this.formatDateToYMD(startDate);
      const endDateString = this.formatDateToYMD(endDate);
      this.scheduleDateFrom = startDateString;
      this.scheduleDateTo = endDateString;
      tglInput.value = `${startDateString} - ${endDateString}`;

      tglInput.dispatchEvent(new Event('input'));
      tglInput.dispatchEvent(new Event('change'));
    }
  }

  formatDateToYMD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Accomodation
  tripAcc: string | null = null; // Durasi yang dipilih
  selectedAcc: string = '';
  totTamu: number = 0;
  scheduleDateFrom: string = '';
  scheduleDateTo: string = '';
  cabinAvailability: Map<number, string> = new Map();
  loadingCabinAvailability: boolean = false;

  openModalAcc(): void {
    if (this.value === 0) {
      return;
    }

    if (this.selectedDate === '') {
      return;
    }

    // Load cabin availability for the selected schedule (hash-based lookup)
    if (this.boat && this.scheduleDateFrom) {
      this.loadingCabinAvailability = true;
      this.apiService
        .getScheduleCabinsByDate(this.boat.id, this.scheduleDateFrom)
        .subscribe(
          (res: any) => {
            this.cabinAvailability.clear();
            if (res.data && Array.isArray(res.data)) {
              for (const cabin of res.data) {
                this.cabinAvailability.set(
                  cabin.id_accomodation,
                  cabin.availability,
                );
              }
            }
            this.loadingCabinAvailability = false;
            this.selectCheapestAccommodation();
          },
          () => {
            this.cabinAvailability.clear();
            this.loadingCabinAvailability = false;
          },
        );
    }

    this.modalAcc.show();
  }

  isCabinUnavailable(acc: any): boolean {
    const avail = this.cabinAvailability.get(acc.id);
    if (acc.cabin_type === 'private') {
      if (avail === undefined) return false;
      return avail === 'closed' || avail === '0';
    }

    // shared: check schedule availability AND total beds
    if (avail !== undefined) {
      if (avail === 'closed') return true;
      const num = Number(avail);
      if (!isNaN(num) && num <= 0) return true;
    }

    // Also unavailable if the cabin has 0 total beds
    if (this.getTotalBeds(acc) <= 0) return true;
    return false;
  }

  /** Get the available spots for a shared cabin from schedule data */
  getCabinAvailableSpots(acc: any): number | null {
    const avail = this.cabinAvailability.get(acc.id);
    if (avail === undefined || avail === 'closed') return null;
    const num = Number(avail);
    return isNaN(num) ? null : num;
  }

  selectedRoomsText: string = ''; // Untuk teks jumlah kamar yang dipilih
  selectedAccommodationsList: { name: string; price: number }[] = [];
  totPrice: number = 0;

  applyAccomodation(): void {
    this.totTamu = this.remainingGuests;
    if (this.totTamu > 0) {
      return;
    }

    // **Langkah 1: Hitung jumlah kamar yang dipilih**
    const selectedRooms = this.selectedAccommodations.length;
    this.selectedRoomsText = `${selectedRooms} room${selectedRooms > 1 ? 's' : ''} selected`;

    this.tripAcc = this.selectedRoomsText;

    // **Langkah 2: Format daftar kamar yang dipilih dengan harga**
    this.selectedAccommodationsList = this.selectedAccommodations.map(
      (acc: any) => ({
        name:
          acc.cabin_type === 'shared'
            ? `${acc.valBed} x ${acc.name}`
            : `${acc.valRoom ? acc.valRoom : acc.valBed} x ${acc.name}`,

        price:
          acc.cabin_type === 'shared' ? acc.valBed * acc.price : acc.totalPrice,
      }),
    );

    // **Langkah 3: Hitung total harga**
    // this.totPrice = this.selectedAccommodations.reduce((sum : any, acc : any) => sum + acc.price, 0);
    this.totPrice = this.getTotal();

    this.formattedTotal = this.totPrice.toString();
    this.prc = this.totPrice;

    if (this.getTotal() > 0) {
      this.totalPrice = this.getTotal().toString();
    } else {
      this.totalPrice = this.getHargaAwalPerOrang().toString();
    }

    this.flatpickrInstance.redraw();
    this.updateDayPrices();

    this.bookForm.patchValue({
      accomodation: this.tripAcc,
      total: this.totPrice,
    });

    this.modalAcc.hide();
  }

  show_pil(acc: any): void {
    acc.isSelected = !acc.isSelected;

    if (acc.isSelected) {
      acc.valBed = 1;
      acc.valRoom = 1;
      acc.valGuests = 1;
      this.calculateTotalPrice(acc);
      this.selectedAccommodations.push(acc);
    } else {
      this.selectedAccommodations = this.selectedAccommodations.filter(
        (a: any) => a !== acc,
      );
      acc.valBed = 0;
      acc.valRoom = 0;
      acc.valGuests = 0;
      acc.totalPrice = 0;
    }
  }

  // Back or deselect the accommodation
  back_pil(acc: any): void {
    acc.isSelected = false;
    acc.valBed = 0;
    acc.valRoom = 0;
    acc.valGuests = 0;
    acc.totalPrice = 0;
  }

  valBed: number = 0; // Nilai default
  min_bed(acc_id: number): number {
    return 1;
  }

  getMaxBeds(acc: any): number {
    const totalBeds = this.getTotalBeds(acc);
    const avail = this.cabinAvailability.get(acc.id);
    if (avail === undefined || avail === 'closed') return totalBeds;
    const num = Number(avail);
    if (isNaN(num)) return totalBeds;
    return Math.min(totalBeds, num);
  }

  dec_bed(acc: any): void {
    if (acc.valBed > this.min_bed(acc.id)) {
      acc.valBed--;
      acc.valGuests = acc.valBed;
    }
  }

  // Increase the number of beds
  inc_bed(acc: any): void {
    if (acc.valBed < this.getMaxBeds(acc)) {
      acc.valBed++;
      acc.valGuests = acc.valBed; // Pastikan guests mengikuti jumlah tempat tidur
    }
  }

  // Check if the decrement button should be disabled
  isDecBedDisabled(acc: any): boolean {
    return acc.valBed <= this.min_bed(acc.id);
  }

  // Check if the increment button should be disabled
  isIncBedDisabled(acc: any): boolean {
    return acc.valBed >= this.getMaxBeds(acc);
  }

  // Validasi jumlah tempat tidur
  validateValueBed(acc: any): void {
    if (acc.valBed < this.min_bed(acc.id)) {
      acc.valBed = this.min_bed(acc.id);
    } else if (acc.valBed > this.getMaxBeds(acc)) {
      acc.valBed = this.getMaxBeds(acc);
    }
  }

  valRoom: number = 1; // Nilai default

  min_room(): number {
    return 1;
  }

  // Maximum number of rooms (always 1)
  max_room(): number {
    return 1;
  }

  // Incrementing the room count (disabled)
  inc_room(): void {
    // No need to do anything as the number of rooms is fixed to 1
  }

  // Decrementing the room count (disabled)
  dec_room(): void {
    // No need to do anything as the number of rooms is fixed to 1
  }

  // Check if the decrement button should be disabled (always true because it's fixed at 1)
  isDecRoomDisabled(): boolean {
    return true;
  }

  // Check if the increment button should be disabled (always true because it's fixed at 1)
  isIncRoomDisabled(): boolean {
    return true;
  }

  getMaxGuests(acc: any): number {
    if (acc.extrabeds?.length > 0) {
      return Math.max(...acc.extrabeds.map((bed: any) => bed.quantity_ex));
    }
    return acc.capacity; // fallback jika tidak ada extrabed
  }

  calculateTotalPrice(acc: any): void {
    const guests = acc.valGuests;
    const capacity = acc.capacity;

    // Jika tamu <= kapasitas, gunakan harga dasar
    if (guests <= capacity) {
      acc.totalPrice = acc.price;
      return;
    }

    // Jika tamu melebihi kapasitas, cek apakah ada extra bed dengan quantity_ex sesuai
    const matchedExtra = acc.extrabeds?.find(
      (bed: any) => bed.quantity_ex === guests,
    );

    if (matchedExtra) {
      acc.totalPrice = matchedExtra.price_ex;
    } else {
      // Tidak cocok dengan extra bed mana pun
      acc.totalPrice = 0;
    }
  }

  valGuests: number = 1; // Default value for guests per room (initially 1)

  // Minimum number of guests per room (always 1)
  min_guests(): number {
    return 1;
  }

  // Validate guests value to ensure it's within the allowed range
  validateValueGuests(acc: any): void {
    const minGuests = this.min_guests();
    const maxGuests = this.getMaxGuests(acc);

    if (acc.valGuests < minGuests) acc.valGuests = minGuests;
    if (acc.valGuests > maxGuests) acc.valGuests = maxGuests;

    this.calculateTotalPrice(acc);
  }

  // Increment the number of guests
  inc_guests(acc: any): void {
    const maxGuests = this.getMaxGuests(acc);
    if (acc.valGuests < maxGuests) {
      acc.valGuests++;
      this.calculateTotalPrice(acc);
    }
  }

  // Decrement the number of guests
  dec_guests(acc: any): void {
    if (acc.valGuests > this.min_guests()) {
      acc.valGuests--;
      this.calculateTotalPrice(acc);
    }
  }

  // Check if the increment button should be disabled
  isIncGuestsDisabled(acc: any): boolean {
    return acc.valGuests >= this.getMaxGuests(acc);
  }

  // Check if the decrement button should be disabled
  isDecGuestsDisabled(acc: any): boolean {
    return acc.valGuests <= this.min_guests();
  }

  getTotalPrice(acc: any): number {
    // Multiply the price per bed by the number of beds selected

    if (acc.cabin_type === 'shared') {
      return acc.price * acc.valBed;
    } else {
      return acc.totalPrice || 0;
    }
  }

  getTotal(): number {
    let total = 0;

    for (const acc of this.accomodations) {
      if (!acc.isSelected) continue;

      const price = Number(acc.price) || 0;
      const valBed = Number(acc.valBed) || 0;
      const totalPrice = Number(acc.totalPrice) || 0;

      if (acc.cabin_type === 'shared') {
        total += price * valBed;
      } else if (acc.cabin_type === 'private') {
        total += totalPrice;
      }
    }

    return total;
  }

  //----------------------------------------------

  // Prevent paste of non-numeric values
  preventPaste(event: any): void {
    event.preventDefault();
  }

  // Prevent keypress for non-numeric characters
  preventKeypress(event: any): void {
    const pattern = /[0-9]/; // Only allow digits
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
  }

  get remainingGuests(): number {
    return (
      this.value -
      this.selectedAccommodations.reduce(
        (sum: any, acc: any) => sum + acc.valGuests,
        0,
      )
    );
  }

  selectedAccommodations: any = [];

  selectCheapestAccommodation(): void {
    if (this.value <= 0 || !this.accomodations?.length) {
      // Reset jika tidak ada tamu
      this.selectedAccommodations = [];
      this.accomodations.forEach((acc) => {
        acc.isSelected = false;
        acc.valBed = 0;
        acc.valRoom = 0;
        acc.valGuests = 0;
      });
      return;
    }

    // Reset semua pilihan sebelumnya
    this.accomodations.forEach((acc) => {
      acc.isSelected = false;
      acc.valBed = 0;
      acc.valRoom = 0;
      acc.valGuests = 0;
    });
    this.selectedAccommodations = [];

    let remainingGuests = this.value;

    // Step 1: Pilih Shared Cabin dulu (bed-based)
    const sharedCabins = this.accomodations
      .filter(
        (acc) =>
          acc.cabin_type === 'shared' &&
          this.getTotalBeds(acc) > 0 &&
          !this.isCabinUnavailable(acc),
      )
      .sort((a, b) => a.price - b.price);

    for (const acc of sharedCabins) {
      if (remainingGuests <= 0) break;

      const availableBeds = this.getMaxBeds(acc);
      const bedsToUse = Math.min(availableBeds, remainingGuests);

      if (bedsToUse > 0) {
        acc.isSelected = true;
        acc.valBed = bedsToUse;
        acc.valRoom = 1;
        acc.valGuests = bedsToUse;
        remainingGuests -= bedsToUse;
        this.selectedAccommodations.push(acc);
      }
    }

    // Step 2: Jika masih sisa, pilih Private Cabin
    if (remainingGuests > 0) {
      const privateCabins = this.accomodations
        .filter(
          (acc) =>
            acc.cabin_type === 'private' &&
            acc.capacity > 0 &&
            !this.isCabinUnavailable(acc),
        )
        .sort((a, b) => a.price / a.capacity - b.price / b.capacity); // Termurah per guest

      for (const acc of privateCabins) {
        if (remainingGuests <= 0) break;

        const guestsToUse = Math.min(acc.capacity, remainingGuests);

        acc.isSelected = true;
        acc.valBed = 1;
        acc.valRoom = 1;
        acc.valGuests = guestsToUse;

        acc.totalPrice = Number(acc.price); // ⬅️ Tambahkan baris ini!

        remainingGuests -= guestsToUse;
        this.selectedAccommodations.push(acc);
      }
    }

    // Step 3: Jika kelebihan kapasitas karena private, buang dari belakang
    if (remainingGuests < 0) {
      for (let i = this.selectedAccommodations.length - 1; i >= 0; i--) {
        const acc = this.selectedAccommodations[i];

        if (acc.cabin_type === 'private') {
          acc.isSelected = false;
          acc.valBed = 0;
          acc.valRoom = 0;
          acc.valGuests = 0;
          this.selectedAccommodations.splice(i, 1);
          remainingGuests += acc.capacity;
        }

        if (remainingGuests >= 0) break;
      }
    }
  }

  formatBookingData(data: any): any {
    // Mapping untuk durasi
    const durationMapping: { [key: string]: string } = {
      per_hari: 'One Day Trip',
      dua_hari: '2D1N',
      tiga_hari: '3D2N',
      empat_hari: '4D3N',
      lima_hari: '5D4N',
      enam_hari: '6D5N',
      tujuh_hari: '7D6N',
      delapan_hari: '8D7N',
      sembilan_hari: '9D8N',
      sepuluh_hari: '10D9N',
    };

    // Format nilai booking
    const formattedDuration = durationMapping[data.duration] || data.duration;
    const formattedGuests = `${data.guests} x Persons`;

    // Format tanggal
    const formattedStartDate = data.startDate
      .split(' - ')
      .map((date: any) => {
        const parsedDate = new Date(date.trim());
        return parsedDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
      })
      .join(' - ');

    // Format total
    // const formattedTotal = `IDR ${Number(data.total).toLocaleString('id-ID')}`;

    return {
      destination: data.destination,
      duration: formattedDuration,
      guests: formattedGuests,
      startDate: formattedStartDate,
      total: data.total,
      id_kapal: data.id_kapal,
      nama_kapal: data.nama_kapal,
      gambar_kapal: data.gambar_kapal,
      boat_kategori: data.boat_kategori,
      trip_kategori: data.trip_kategori,
      accomodations: this.selectedAccommodationsList,
    };
  }

  pesan(): void {
    this.submitted = true;

    if (this.bookForm.valid) {
      this.isLoading = true;

      const boatData = {
        id_kapal: this.boat?.id,
        nama_kapal: this.boat?.nama_kapal,
        gambar_kapal: this.boat?.ms_gambarkapals[0] || 'No image available', // Item pertama dari ms_gambarkapals
        boat_kategori: this.boat?.boat_kategori,
        trip_kategori: this.boat?.trip_kategori,
      };

      const bookingData = {
        destination: this.destinations,
        duration: this.boat?.durasi,
        guests: this.bookForm.value.tamu,
        startDate: this.bookForm.value.tgl,
        total: this.bookForm.value.total,
        accomodations: this.selectedAccommodationsList,
        ...boatData,
      };

      // // Format booking data
      const formattedData = this.formatBookingData(bookingData);

      // // Simpan data terformat ke localStorage

      console.log(formattedData);

      localStorage.setItem(
        'formattedBookingData',
        JSON.stringify(formattedData),
      );

      this.authService.checkLocalStorage();

      // Navigasi ke halaman checkout dengan data terformat
      this.router.navigate(['/checkout'], {
        state: { bookingData: formattedData },
      });

      this.submitted = false;
      this.isLoading = false;
    }
  }

  openModalPrice(): void {
    if (this.priceModal) {
      this.priceModal.show();
    }
  }

  getSleepInfo(acc: any): string {
    const capacity = Number(acc.capacity) || 0;

    const totalExtraConfigs = Array.isArray(acc.extrabeds)
      ? acc.extrabeds.length
      : 0;

    if (totalExtraConfigs > 0) {
      return `Sleeps: ${capacity} + ${totalExtraConfigs} extra bed`;
    } else {
      return `Sleeps: ${capacity}`;
    }
  }

  getImageUrl(path: string): string {
    return getBoatImageUrl(path);
  }

  getAccommodationUrl(path: string): string {
    return getAccommodationImageUrl(path);
  }

  getPriceUrl(path: string): string {
    return getPriceImageUrl(path);
  }
}
